import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';
import type { Size } from '../types/Size';

export function composeSizeClasses(width: Adaptive<Size>): string {
    if (typeof width === 'object') {
        return clsx(
            width.base && `size-${width.base}`,
            width.sm && `sm:size-${width.sm}`,
            width.md && `md:size-${width.md}`,
            width.lg && `lg:size-${width.lg}`,
            width.xl && `xl:size-${width.xl}`,
            width['2xl'] && `2xl:size-${width['2xl']}`
        );
    }

    return `size-${width}`;
}
